<template>     
  <div style="margin-bottom: 60px">
    <button type="button" class="btn btn-danger" style="float:right;;font-weight:bold;width:12%; margin-left: 1%" @click="Annulla()">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
    <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:12%" :disabled="DisableConferma" @click="Conferma()">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
  </div>
  <div class="container" v-if="Admin" :style="{'background-color' : Arancione}">
    <h4 class="ZMLabel" style="margin-bottom: 30px; font-size: 20px">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_DATI_GEN',this.LinguaUtente) }}</h4>
    <div class="ZMContainerFlex col-md-5">
      <div class="ZMNuovaRigaFlex">
        <label class="ZMLabel col-md-4">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</label>
        <input class="form-control" v-model="SchedaSito.Dati.NOME" type="text" :placeholder="this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente)">            
      </div>
      <div class="ZMNuovaRigaFlex" style="align-items: flex-end">
        <label class="ZMLabel col-md-4">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_DATI_ABILITATO',this.LinguaUtente) }}</label>
        <input class="form-control" v-model="SchedaSito.Dati.ABILITATO" type="checkbox" style="width: 20px">            
      </div>          
      <div class="ZMNuovaRigaFlex" style="align-items: flex-end">
        <label class="ZMLabel col-md-4">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_DATI_PRIORITA',this.LinguaUtente) }}</label>
        <VUESlider style="width:50%" :min="1" :max="5" v-model="SchedaSito.Dati.PRIORITA"></VUESlider>     
      </div> 

      <div class="ZMNuovaRigaFlex">
        <label class="ZMLabel col-md-4">{{ this.GetTraduzioneLabel('Generic','TKN_SFONDO_ALLINEAMENTO',this.LinguaUtente) }}</label>
        <div style="background-color: white;width: 30%;">
          <div class="ZMColorPickerDiv" :style="{'background-color' : SchedaSito.Dati.SFONDO_ALLINEAMENTO, 'width' : '100%', 'float' : 'left'}" @click="ApriPopupColorPicker()">&nbsp;</div>
        </div>
      </div>  

      <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker> 
      
      <div class="ZMNuovaRigaFlex">
        <label class="ZMLabel col-md-4">{{ this.GetTraduzioneLabel('Generic','TKN_NOTE_LEGALI',this.LinguaUtente) }}</label>
        <div style="background-color: white;width: 30%;">
          <div class="ZMColorPickerDiv" :style="{'background-color' : SchedaSito.Dati.NOTE_LEGALI, 'width' : '100%', 'float' : 'left'}" @click="ApriPopupColorPickerFooter()">&nbsp;</div>
        </div>
      </div>
      <VUEColorPicker :Popup="PopupColorFooter" Programma="DMSEW" :Colore="ColoreFooterEdit" @OnClickConfermaPopup="ConfermaColoreFooter()" @OnClickChiudiPopup="AnnullaColoreFooter()"></VUEColorPicker> 

    </div>
    <div class="ZMContainerFlex col-md-7" style="align-content:center">
      <div class="ZMNuovaRigaFlex">
        <label class="btn btn-info" type="button" style="width:32%;">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_INS_IMG',this.LinguaUtente) }}      
          <input style="display:none;" type="file" id="InputImmagineSito" @change="LoadImmagineFromFile(elemento)" accept="image/*">
        </label>
        <div style="width:2%;"></div>
        <label class="btn btn-info" type="button" style="width:32%;">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_INCOLLA_IMG',this.LinguaUtente) }}        
          <input style="display:none;" @click="IncollaImmagine()">
        </label>
        <div style="width:2%;"></div>
        <button class="btn btn-danger" style="width:32%;" @click="EliminaImmagine()">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_DEL_IMG',this.LinguaUtente) }}</button>
      </div>
      <div id="ImgBox">
        <img v-if="SchedaSito.Dati.SrcImmagine != undefined" style="width:100%" :src="SchedaSito.Dati.SrcImmagine"/>
      </div>
    </div>
  </div>
  <div class="container" :style="{'background-color' : Arancione}" style="margin: 20px auto; padding: 20px 20px;">
    <h4 class="ZMLabel" style="margin-bottom: 30px; font-size: 20px">{{ this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_UTENTI_ASS',this.LinguaUtente) }}</h4>
    <div style="height: 40px;">          
      <button type="button" class="btn btn-info" style="float:right;font-weight:bold; width: 24%" :disabled="UtenteSelezionato == -1" @click="InserisciUtente()">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
      <div style="width:1%;float:right">&nbsp;</div>
      <VUEInputUtenti style="width: 75%; float:right" v-model="UtenteSelezionato" :UtentiDaEscludere="UtentiAssegnati"></VUEInputUtenti>
    </div>
    <div class="ZMUserBox">          
      <div v-for="utente in UtentiAssegnati" :key="utente.CHIAVE" style="display: flex;">
        <div style="flex-grow: 8">
          <img class="ZMUserImgBox img-circle img-thumbnail" v-if="utente.IMMAGINE" :src="utente.IMMAGINE"/>
          <img class="ZMUserImgBox img-circle img-thumbnail" v-else src="@/assets/images/avatar_default.jpg">
        </div>
        <div style="flex-grow:92">
          <label style="width:90%">{{utente.RAGIONE_SOCIALE}}</label>
          <i class="fa fa-trash-o text-danger ZMIconButton" style="cursor:pointer; margin-right: 5%; width:5%" @click="RimuoviUtente(utente.CHIAVE)"></i>
        </div>
      </div>
    </div>
  </div>
 </template>

<script>
import { RUOLI, SFONDO, IMMAGINE_SITO_DEFAULT, SystemInformation } from '@/SystemInformation';
import VUEInputUtenti from '../components/InputComponents/VUEInputUtenti.vue'
import { TSchedaGenerica } from '@/utils/ZSchedaGenerica';
import { TAdvQueryOggettoBlob, OPERAZIONE_BLOB } from '@/utils/ZAdvQuery.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZGenericFunct } from '@/utils/ZGenericFunct';
import VUESlider from 'vue-slider-component'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'

export class TSchedaSito
{
  constructor(Chiave, Admin)
  {
    this.Admin = Admin
    this.Clear()
    this.Dati.CHIAVE = Chiave
  }

  Disponi()
  {
    let Self = this
    let Modello = this.Admin ? 'Admin_Siti' : 'SuperUtente_Siti'
    SystemInformation.AdvQuery.GetSQL(Modello,{ Chiave: this.Dati.CHIAVE },
                                      function (Results)
                                      {
                                        let ArrayInfo       = SystemInformation.AdvQuery.FindResults(Results, 'Sito')
                                        let ArrayInfoUtenti = SystemInformation.AdvQuery.FindResults(Results, 'Utenti')
                                        if (ArrayInfo != undefined && ArrayInfoUtenti != undefined)
                                        {
                                          let Sito = ArrayInfo[0]
                                          Self.Dati.NOME = TSchedaGenerica.DisponiFromString(Sito.NOME)
                                          Self.Dati.ABILITATO = TSchedaGenerica.DisponiFromBoolean(Sito.ABILITATO)
                                          Self.Dati.ALLEGATO = TSchedaGenerica.DisponiFromString(Sito.ALLEGATO)
                                          Self.Dati.PRIORITA = TSchedaGenerica.DisponiFromInteger(Sito.PRIORITA)
                                          Self.Dati.SFONDO_ALLINEAMENTO = TSchedaGenerica.DisponiFromString(Sito.SFONDO_ALLINEAMENTO)
                                          Self.Dati.NOTE_LEGALI = TSchedaGenerica.DisponiFromString(Sito.NOTE_LEGALI)
                                          if(Self.Dati.ALLEGATO == undefined || Self.Dati.ALLEGATO == '')
                                          {
                                            Self.Dati.ALLEGATO = IMMAGINE_SITO_DEFAULT
                                            Self.Dati.SrcImmagine = IMMAGINE_SITO_DEFAULT
                                          }
                                          else
                                          {
                                            Self.SearchImmagine(Self.Dati.ALLEGATO, function()
                                                                                    {
                                                                                      Self.Dati.ImmaginePresente = true
                                                                                    })
                                          }
                                          Self.Dati.UtentiAssegnati = ArrayInfoUtenti                                          
                                        }
                                        else
                                        {
                                          alert(this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_ERR_CARICAMENTO_SITO',this.LinguaUtente))
                                        }
                                      },
                                      function (HTTPError, SubHTTPError, Response)
                                      {
                                        SystemInformation.HandleError(HTTPError, SubHTTPError, Response);
                                      },"SelectDettaglio");
  }

  SearchImmagine(PathInfo,OnSuccess = undefined)
  {
    let Self = this
    SystemInformation.AdvQuery.GetAttachment(PathInfo.split(';')[1],  function(Result)
                                                                      {
                                                                        Self.Dati.SrcImmagine = PathInfo.split(';')[0] + ';base64,' + Result
                                                                        if (OnSuccess != undefined)
                                                                        {
                                                                          OnSuccess()
                                                                        }
                                                                      },
                                                                      function(HTTPError,SubHTTPError,Response)
                                                                      {
                                                                        if (Response != 20)
                                                                          SystemInformation.HandleError(HTTPError,SubHTTPError,Response)
                                                                        else
                                                                        {
                                                                          console.error(this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_ERR_IMG_NON_TROVATA',this.LinguaUtente))
                                                                          Self.Dati.SrcImmagine = IMMAGINE_SITO_DEFAULT
                                                                        }
                                                                      })
  }

  DeleteImmagine()
  {
    let Self = this
    Self.Dati.SrcImmagine = IMMAGINE_SITO_DEFAULT
    Self.Dati.ImmaginePresente = false
    /*this.SearchImmagine(IMMAGINE_SITO_DEFAULT,  function()
                                                {
                                                  Self.Dati.ImmaginePresente = false
                                                })*/
  }

  AggiungiUtente(Utente)
  {
    this.Dati.UtentiAssegnati.push(Utente)
  }

  Clear()
  {
    this.Dati = {
                  NOME                : '',
                  ABILITATO           : true,
                  UtentiAssegnati     : [],
                  ALLEGATO            : IMMAGINE_SITO_DEFAULT,
                  PRIORITA            : 1,
                  SFONDO_ALLINEAMENTO : 'rgb(255 255 255 / 0)',
                  NOTE_LEGALI         : 'rgb(0,0,0)',
                  ImmaginePresente    : false
                }
  }

  GetObjAllegatoForRecord(Chiave)
  {
    if (this.Dati.ImmaginePresente)
    {
      let AllegatoBase64 = this.Dati.SrcImmagine.split("base64,")
      if (Chiave != undefined && this.Dati.ALLEGATO != IMMAGINE_SITO_DEFAULT)
      {
        let Posizione = ''
        let ArrayInfo = this.Dati.ALLEGATO.split(";")
        Posizione = ArrayInfo[1]
        return new TAdvQueryOggettoBlob(OPERAZIONE_BLOB.Update,
                                        TSchedaGenerica.PrepareForRecordString(AllegatoBase64[1]),
                                        AllegatoBase64[0],
                                        Posizione,
                                        'Sito')
      }
      else
      {
        return new TAdvQueryOggettoBlob(OPERAZIONE_BLOB.Inserimento,
                                        TSchedaGenerica.PrepareForRecordString(AllegatoBase64[1]),
                                        AllegatoBase64[0],
                                        '',
                                        'Sito')
      }
    }
  }

  Registra(OnSuccess)
  {
    let ObjQuery = {Operazioni : []}
    let Modello = 'SuperUtente_Siti'
    let Chiave = this.Dati.CHIAVE == -1 ? undefined : this.Dati.CHIAVE
    if (this.Admin)
    {
      Modello = 'Admin_Siti'
      ObjQuery.Operazioni.push({
                                  Query : this.Dati.CHIAVE == -1 ? 'Insert' : 'Update',
                                  Parametri : {
                                                CHIAVE              : Chiave,
                                                NOME                : this.Dati.NOME,
                                                ABILITATO           : this.Dati.ABILITATO,
                                                ALLEGATO            : this.GetObjAllegatoForRecord(Chiave),
                                                PRIORITA            : this.Dati.PRIORITA,
                                                SFONDO_ALLINEAMENTO : this.Dati.SFONDO_ALLINEAMENTO,
                                                NOTE_LEGALI         : this.Dati.NOTE_LEGALI
                                              }
                                })
    }
    for (let i = 0; i < this.Dati.UtentiAssegnati.length; i++)
    {
      let Utente = this.Dati.UtentiAssegnati[i]
      if (Utente.Eliminato && !Utente.Nuovo)
      {
        ObjQuery.Operazioni.push({
                                    Query : 'DeleteUtente',
                                    Parametri : {
                                                  ID_UTENTE : Utente.CHIAVE,
                                                  ID_SITO   : Chiave
                                                }
                                  })
      }
      else
        if (Utente.Nuovo)
        {
          ObjQuery.Operazioni.push({
                                      Query : 'InsertUtente',
                                      Parametri : {
                                                    ID_UTENTE : Utente.CHIAVE,
                                                    ID_SITO   : Chiave
                                                  }
                                    })
        }
    }
    let Self = this
    SystemInformation.AdvQuery.PostSQL(Modello, ObjQuery, function(){
                                                                      if (Self.Dati.ALLEGATO != IMMAGINE_SITO_DEFAULT && !Self.Dati.ImmaginePresente)
                                                                      {
                                                                        let Posizione = Self.Dati.ALLEGATO.split(";")[1]
                                                                        let LsAttachmentDaEliminare = []
                                                                        LsAttachmentDaEliminare.push(Posizione)
                                                                        SystemInformation.AdvQuery.DeleteAttachment(LsAttachmentDaEliminare,
                                                                                                      function()
                                                                                                      {
                                                                                                        OnSuccess()
                                                                                                      },
                                                                                                      SystemInformation.HandleError)
                                                                      }
                                                                      else
                                                                        OnSuccess()
                                                                    }, SystemInformation.HandleError)
  }
}

export default 
{
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              Admin             : false,
              Arancione         : SFONDO.Arancione,
              Marrone           : SFONDO.Marrone,
              UtenteSelezionato : -1,
              SchedaSito        : {},
              LinguaUtente      : SystemInformation.UserInformation.Lingua,
              ImageMaxWidth     : 0,
              PopupColorPicker  : false,
              PopupColorFooter  : false,
              ColoreInModifica  : {},
              ColoreFooterEdit  : {},
           };
  },
  components: 
  {
    VUEInputUtenti,
    VUESlider,
    VUEColorPicker
  },
  methods:
  {
    ApriPopupColorPicker()
    {
      this.ColoreInModifica.Colore = this.SchedaSito.Dati.SFONDO_ALLINEAMENTO
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.SchedaSito.Dati.SFONDO_ALLINEAMENTO = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    ApriPopupColorPickerFooter()
    {
      this.ColoreFooterEdit.Colore = this.SchedaSito.Dati.NOTE_LEGALI
      this.PopupColorFooter = true
    },

    ConfermaColoreFooter()
    {
      this.SchedaSito.Dati.NOTE_LEGALI = this.ColoreFooterEdit.Colore
      this.AnnullaColoreFooter()
    },

    AnnullaColoreFooter()
    {
      this.ColoreFooterEdit = {}
      this.PopupColorFooter = false
    },

    InserisciUtente()
    {
      let index = this.SchedaSito.Dati.UtentiAssegnati.findIndex(element=>(element.CHIAVE == this.UtenteSelezionato))
      if (index != -1)
      {
        this.SchedaSito.Dati.UtentiAssegnati[index].Eliminato = false
        return
      }
      let Utente = SystemInformation.Configurazioni.Utenti.find(element=>(element.CHIAVE == this.UtenteSelezionato))
      Utente.Nuovo = true
      this.SchedaSito.AggiungiUtente(Utente)
      this.UtenteSelezionato = -1
    },

    RimuoviUtente(IdUtente)
    {
      let Elemento = this.SchedaSito.Dati.UtentiAssegnati.find(element=>(element.CHIAVE == IdUtente))
      Elemento.Eliminato = true      
    },

    Conferma()
    {
      let Self = this
      this.SchedaSito.Registra( function()
                                {
                                  Self.Annulla()
                                  SystemInformation.GetConfigurazioni()
                                })
    },

    Annulla()
    {
      this.$router.go(-1)
    },

    LoadImmagineFromFile()
    {
      let Self    = this;
      let Reader  = new FileReader()
      let ImgFile = document.getElementById('InputImmagineSito')
      
      Reader.readAsDataURL(ImgFile.files[0])

      Reader.onload = function (e) 
      {
        var Img = new Image()
        Img.onload = function () 
        {
          Img.onload = undefined;
          Self.SchedaSito.Dati.SrcImmagine = Img.src
          Self.SchedaSito.Dati.ImmaginePresente = true
        }
        Img.src = e.target.result
      } 
    },

    IncollaImmagine()
    {
      var Self = this
      navigator.clipboard.read().then(function(clipboardContents)
      {
        clipboardContents.forEach(function(Elemento)
        {
          Elemento.getType(Elemento.types[0]).then(function(Blob)
          {
            if (Blob.type == 'image/jpeg' || Blob.type == 'image/png')
            {
              var reader = new FileReader();
              reader.onload = function(event) 
              {
                Self.SchedaSito.Dati.SrcImmagine  = event.target.result
                Self.SchedaSito.Dati.ImmaginePresente = true
              };
              reader.readAsDataURL(Blob);
            }
            else alert(this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_ERR_NON_IMG',this.LinguaUtente))
          });
        });
      }, function(){alert(this.GetTraduzioneLabel('VUEModificaSiti','TKN_MOD_SITI_ERR_IMG_FORMATO',this.LinguaUtente))});
    },

    EliminaImmagine()
    {
      this.SchedaSito.DeleteImmagine()
    }
  },
  computed:
  {
    UtentiAssegnati:
    {
      get()
      {
        let UtentiVisualizzati = []
        this.SchedaSito.Dati.UtentiAssegnati.forEach( function(element)
                                                      {
                                                        if (!element.Eliminato)
                                                          UtentiVisualizzati.push(element)
                                                      })
        return UtentiVisualizzati
      }
    },
    DisableConferma:
    {
      get()
      {
        return (this.SchedaSito.Dati.NOME == '')
      }
    }
  },
  beforeMount()
  {
    this.Admin = SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore
    let Parametri = TZGenericFunct.GetURLParameters()
    this.SchedaSito = new TSchedaSito(Parametri.Sito, this.Admin)
    if (this.SchedaSito.Dati.CHIAVE != -1)
      this.SchedaSito.Disponi()
    else
      this.SchedaSito.Dati.SrcImmagine = IMMAGINE_SITO_DEFAULT
  },
}
</script>